export default __webpack_public_path__ + "static/media/folder-close.6ae1b58d.svg";